import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const numbusterDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#6EE7B7', // mint green
      },
      secondary: {
        main: '#818CF8', // soft indigo
      },
      error: {
        main: '#F87171',
      },
      warning: {
        main: '#FBBF24',
      },
      info: {
        main: '#60A5FA',
      },
      success: {
        main: '#34D399',
      },
      background: {
        default: '#0F172A', // slate-900
        paper: '#1E293B', // slate-800
      },
      banner: {
        info: '#1E40AF',
        error: '#991B1B',
        text: '#F1F5F9',
        link: '#6EE7B7',
      },
      errorBackground: '#7F1D1D',
      warningBackground: '#78350F',
      infoBackground: '#1E3A5F',
      navigation: {
        background: '#0F172A',
        indicator: '#6EE7B7',
        color: '#94A3B8',
        selectedColor: '#F1F5F9',
        navItem: {
          hoverBackground: '#1E293B',
        },
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  pageTheme: {
    home: genPageTheme({
      colors: ['#065F46', '#0F172A'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#1E40AF', '#0F172A'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#6D28D9', '#0F172A'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#065F46', '#1E293B'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#065F46', '#1E293B'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#1E40AF', '#1E293B'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#374151', '#0F172A'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#065F46', '#0F172A'],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: ['#6D28D9', '#0F172A'],
      shape: shapes.wave,
    }),
  },
});

export const numbusterLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#047857', // emerald-700
      },
      secondary: {
        main: '#6366F1', // indigo-500
      },
      error: {
        main: '#DC2626',
      },
      warning: {
        main: '#D97706',
      },
      info: {
        main: '#2563EB',
      },
      success: {
        main: '#059669',
      },
      background: {
        default: '#F8FAFC', // slate-50
        paper: '#FFFFFF',
      },
      banner: {
        info: '#2563EB',
        error: '#DC2626',
        text: '#1E293B',
        link: '#047857',
      },
      errorBackground: '#FEE2E2',
      warningBackground: '#FEF3C7',
      infoBackground: '#DBEAFE',
      navigation: {
        background: '#0F172A',
        indicator: '#6EE7B7',
        color: '#94A3B8',
        selectedColor: '#F1F5F9',
        navItem: {
          hoverBackground: '#1E293B',
        },
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  pageTheme: {
    home: genPageTheme({
      colors: ['#047857', '#065F46'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#2563EB', '#1E40AF'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#7C3AED', '#6D28D9'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#047857', '#065F46'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#047857', '#065F46'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#2563EB', '#1E40AF'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#475569', '#334155'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#047857', '#065F46'],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: ['#7C3AED', '#6D28D9'],
      shape: shapes.wave,
    }),
  },
});
